import {Component, Inject, inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-activity-search-engine-dialog',
    templateUrl: './activity-search-engine-dialog.component.html',
    styleUrls: ['./activity-search-engine-dialog.component.scss'],
    standalone: false
})
export class ActivitySearchEngineDialogComponent {


    private dialogRef = inject(MatDialogRef<ActivitySearchEngineDialogComponent>);

    constructor(@Inject(MAT_DIALOG_DATA) public data: never) {
    }

    public onSelectionValidated($event: (string | number)[]): void {
        this.dialogRef.close($event)
    }
}